import styled from "styled-components";

export const MessageError = styled.p`
    font-size: 13px;
    color: red;
    margin-bottom: 5px;
`;

export const Container = styled.div`
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;

    svg {
        color: #234e52;
        margin-right: 16px;
    }
`;
